export default __webpack_public_path__ + "static/media/icon-close-gray.e6c99edc.svg";